import { render } from "./InfoModal.vue?vue&type=template&id=7bb839a5&scoped=true"
import script from "./InfoModal.js?vue&type=script&lang=js"
export * from "./InfoModal.js?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=7bb839a5&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb839a5"]])

export default __exports__